import {
  WebModuleDefinition,
  WebModuleDefinitionSchema,
  WebSurfaceDefinition,
  WebSurfaceDefinitionSchema
} from '.';

export type Definition = WebModuleDefinition | WebSurfaceDefinition;

export function createDefinition<const D extends Definition>(definition: D): D {
  const type = definition.type;
  switch (type) {
    case 'module': {
      return WebModuleDefinitionSchema.parse(definition) as D;
    }
    case 'surface': {
      return WebSurfaceDefinitionSchema.parse(definition) as D;
    }
  }
}
